import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IActivityDetailComponentProps } from './interfaces';

@observer
class LienholderPostedNoteActivity extends Component<IActivityDetailComponentProps> {
  public render () {
    return (
      <>
        <h4>Note from lienholder</h4>
        <p className='quote'>{this.props.activity.note}</p>
      </>
    );
  }
}

export default LienholderPostedNoteActivity;
